import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Button from '../../Button/Button';
import { setCreateNewOrderStep } from '../../../thunks/coilovers/orders/createNewOrder';
import { IconArrowLeft, IconArrowRight, IconLoading } from '../../../assets/icon';
import buttonTypes from '../../../constants/buttonTypes';

const StepperNavigationBtn = ({
 next, prev, nextText, disabledNext, loading, onSubmit
}) => {
  const dispatch = useDispatch();
  const onNext = () => onSubmit?.() || dispatch(setCreateNewOrderStep(next));
  const onPrev = () => dispatch(setCreateNewOrderStep(prev));

  return (
    <div className="flex justify-between">
      <div>
        {prev && (
          <Button
            text="Back"
            onClick={onPrev}
            icon={<IconArrowLeft />}
            type={buttonTypes.LIGHT_PRIMARY}
          />
        )}
      </div>
      <Button
        disabled={disabledNext}
        text={loading ? 'Loading...' : nextText}
        onClick={onNext}
        iconRight={loading ? (
          <div className="spin">
            <IconLoading />
          </div>
          ) : <IconArrowRight />}
      />
    </div>
  );
};

StepperNavigationBtn.propTypes = {
  next: PropTypes.string.isRequired,
  prev: PropTypes.string,
  nextText: PropTypes.string,
  loading: PropTypes.bool,
  disabledNext: PropTypes.bool,
  onSubmit: PropTypes.func,
};

StepperNavigationBtn.defaultProps = {
  prev: '',
  nextText: 'Continue',
  loading: false,
  disabledNext: false,
  onSubmit: undefined,
};

export default StepperNavigationBtn;
